import "./styles.css";
import { Outlet, useLocation } from "react-router-dom";
import ActionsBar from "@/UI/components/ActionsBar";
import SidePopup from "@/UI/popups/SidePopup";
import ProductsForm from "@/UI/forms/ProductsForm";
import CategoriesForm from "@/UI/forms/CategoriesForm";
import useLangStore from "@/hooks/useLangStore";
import usePopupStore from "@/hooks/usePopupStore";
import translations from "@/config/translations";

export default function ProductsScreen() {
    const { lang } = useLangStore();
    const t = translations[lang ?? "ar"];
    const { addComp, removeComp } = usePopupStore();
    const location = useLocation();

    const isCategories = location.pathname.includes("/categories");

    const tabs = [
        { label: t.nav.products, path: "/products", end: true },
        { label: t.nav.categories, path: "/products/categories" },
    ];

    const filterContent = <input className="actions-bar-search-input" placeholder={t.actionsBar.search} />;

    const openAddProductForm = () => {
        const name = "add-product";
        removeComp(name);
        addComp({
            name,
            Component: SidePopup,
            details: {
                title: t.productForm.createTitle,
                Content: ProductsForm,
                contentDetails: {
                    onSuccess: () => {
                        window.dispatchEvent(new CustomEvent("products:refresh"));
                    },
                },
            },
            place: "end",
            anim: "endSlide",
            cover: "shaded",
            coverClose: true,
        });
    };

    const openAddCategoryForm = () => {
        const name = "add-category";
        removeComp(name);
        addComp({
            name,
            Component: SidePopup,
            details: {
                title: t.categoryForm.createTitle,
                Content: CategoriesForm,
                contentDetails: {
                    onSuccess: () => {
                        window.dispatchEvent(new CustomEvent("categories:refresh"));
                    },
                },
            },
            place: "end",
            anim: "endSlide",
            cover: "shaded",
            coverClose: true,
        });
    };

    const handleAdd = isCategories ? openAddCategoryForm : openAddProductForm;

    return (
        <div className="products-screen">
            <ActionsBar tabs={tabs} onAdd={handleAdd} filterContent={filterContent} />
            <div className="products-screen-content">
                <Outlet />
            </div>
        </div>
    );
}
